import { render, staticRenderFns } from "./HeadCountDetails.vue?vue&type=template&id=47f7aec0&"
import script from "./HeadCountDetails.vue?vue&type=script&lang=js&"
export * from "./HeadCountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports